const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

const DOWNLOAD_USERS_REPORT_REQUEST = 'DOWNLOAD_USERS_REPORT_REQUEST';
const DOWNLOAD_USERS_REPORT_SUCCESS = 'DOWNLOAD_USERS_REPORT_SUCCESS';
const DOWNLOAD_USERS_REPORT_FAILURE = 'DOWNLOAD_USERS_REPORT_FAILURE';

export default {
  FETCH_USERS_REQUEST,
  FETCH_USERS_FAILURE,
  FETCH_USERS_SUCCESS,
  DOWNLOAD_USERS_REPORT_REQUEST,
  DOWNLOAD_USERS_REPORT_FAILURE,
  DOWNLOAD_USERS_REPORT_SUCCESS,
};



// WEBPACK FOOTER //
// ./src/modules/user/actions/users.action-types.js